import React, { Component } from "react"
import Modal from "react-modal"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"
import InterestCollection2ModalUI from "./InterestCollection2ModalUI"

class InterestCollection2ModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      //
      submitted: false,
      //
      collectionDate: '',
      collectionDateError: null,
      // //
      // collected: ''
    }
  }

  render() {
    return (
      <InterestCollection2ModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        //
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        //
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        //
        collectionDate={this.state.collectionDate}
        onCollectionDateChange={(selectedDateISO) => { this.setState({ collectionDate: selectedDateISO }) }}
        collectionDateError={this.state.collectionDateError}
        setCollectionDateError={(error) => { this.setState({ collectionDateError: error }) }}
      // //
      // collected={this.state.collected}
      // onCollectedChange={() => { this.setState({ collected: !this.state.collected }) }}
      />
    )
  }

  onCancelClick = () => {
    this.setState({
      submitted: false,
      errorList: null
    })
    this.props.onCancelClick()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/customerInvoices/${this.props.selectedCustomerInvoiceId}/interestPayments`,
      this.onSubmitCallback, {
      interestCollectionDate: this.state.collectionDate,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default InterestCollection2ModalSF;